/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_Total_AmountInputs */

const fr_membership_section_total_amount = /** @type {(inputs: Membership_Section_Total_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant total`)
};

/**

* @param {Membership_Section_Total_AmountInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_total_amount = /** @type {((inputs?: Membership_Section_Total_AmountInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_Total_AmountInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_total_amount(inputs)
});